<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const serviceTypeOptions = [
        `Impression numérique`,
        `Impression offset`,
        `Sérigraphie`,
        `Objets personnalisés`,
        `Tampographie`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const productTypesOptions = [
        `Flyers & brochures`,
        `Cartes de visite`,
        `Calendriers & Agenda`,
        `Objets publicitaires`,
        `Textiles`,
        `Livres, magazines`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const printVolumeOptions = [`Petit tirage`, `Moyen tirage`, `Grand tirage`].map(
        (v) => ({ label: v, value: v, key: v }),
    );

    const deliveryDeadlineOptions = [
        `Urgent (moins d'une semaine)`,
        `Standard (1-2 semaines)`,
        `Flexible (plus de 2 semaines)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.imprimerie.serviceType}
        class=""
        let:field
        let:id
        label={`Quel type de service d'impression recherchez-vous ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={serviceTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.imprimerie.productTypes}
        class=""
        let:field
        let:id
        label={`Quels types de produits souhaitez-vous imprimer ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={productTypesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.imprimerie.printVolume}
        class=""
        let:field
        let:id
        label={`Quel est le volume d'impression estimé pour votre projet ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={printVolumeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.imprimerie.deliveryDeadline}
        class=""
        let:field
        let:id
        label={`Quel est votre délai de livraison souhaité pour ce projet ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={deliveryDeadlineOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
